module.exports = __webpack_public_path__ + "static/media/super_pack_fr_ete_chien.5aaa147d.png";